var _require = require('crypto'),
    createHmac = _require.createHmac;

var _require2 = require('../help/consts'),
    KEYOBJECT = _require2.KEYOBJECT;

var timingSafeEqual = require('../help/timing_safe_equal');

var resolveNodeAlg = require('../help/node_alg');

var _require3 = require('../help/key_object'),
    asInput = _require3.asInput;

var sign = function sign(jwaAlg, hmacAlg, _ref, payload) {
  var keyObject = _ref[KEYOBJECT];
  var hmac = createHmac(hmacAlg, asInput(keyObject, false));
  hmac.update(payload);
  return hmac.digest();
};

var verify = function verify(jwaAlg, hmacAlg, key, payload, signature) {
  var expected = sign(jwaAlg, hmacAlg, key, payload);
  var actual = signature;
  return timingSafeEqual(actual, expected);
};

module.exports = function (JWA, JWK) {
  ['HS256', 'HS384', 'HS512'].forEach(function (jwaAlg) {
    var hmacAlg = resolveNodeAlg(jwaAlg);
    JWA.sign.set(jwaAlg, sign.bind(undefined, jwaAlg, hmacAlg));
    JWA.verify.set(jwaAlg, verify.bind(undefined, jwaAlg, hmacAlg));

    JWK.oct.sign[jwaAlg] = JWK.oct.verify[jwaAlg] = function (key) {
      return key.use === 'sig' || key.use === undefined;
    };
  });
};